import React from "react";

import { Card, CardContent } from "@/components/ui/card";
import { CardHeader } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { useLocation } from "react-router-dom";
import PlanCoverageSelector from "../components/my-benefit/plan-coverage-selector";
import { planCoverageEnabledRoutes } from "@/constants";
import useUserInfo from "@/hooks/use-user-info";
import RequestIdCard from "../components/id-card/request-id-card";
import ScreenRouteNames from "@/constants/screen-route-names";
import Footer from "@/pages/components/footer";
import { isCoverageActiveOrExtended } from "@/lib/utils";

export default function PageContainer({
  children,
  title,
  enableBackButton: _enableBackButton = false,
  headerLeftContent,
  headerRightContent,
}: {
  children: React.ReactNode;
  title?: string;
  enableBackButton?: boolean;
  headerLeftContent?: React.ReactNode;
  headerRightContent?: React.ReactNode;
}) {
  const location = useLocation();
  const userInfo = useUserInfo();
  // console.log("@pathbane", location.pathname, planCoverageEnabledRoutes[1]);

  function isPlanCoverageRoute(pathname: string) {
    const isRouteIncluded = planCoverageEnabledRoutes.some((route) =>
      pathname.replace(/^\/+/, "").startsWith(route),
    );
    // console.log(isRouteIncluded);
    return isRouteIncluded;
  }

  return (
    <div className="full-height-in-third-app mb-0 flex h-[calc(100vh-64px)] min-w-[320px] flex-col overflow-hidden overflow-y-auto bg-slate-100 px-12 py-4">
      <Card className="mx-auto flex w-full flex-1 flex-col rounded-t-2xl">
        <CardHeader className="relative flex flex-col items-center justify-between gap-x-4 border-b px-2 py-4 sm:flex-row">
          <div className="flex flex-1 justify-start gap-2">
            {headerLeftContent}
            {location.pathname.slice(1) === ScreenRouteNames.ID_CARD.path && (
              <div className="flex gap-2">
                <RequestIdCard />
              </div>
            )}
          </div>

          <Label className="flex-1 overflow-visible text-center text-lg">
            {title}
          </Label>

          <div className="flex flex-1 justify-end gap-2">
            {isPlanCoverageRoute(location.pathname) && (
              <div className="w-[200px]">
                {userInfo.planCoverageInfo.filter(isCoverageActiveOrExtended)
                  .length > 1 ? (
                  <PlanCoverageSelector />
                ) : null}
              </div>
            )}

            {headerRightContent}
          </div>
        </CardHeader>
        <CardContent className="m-0 flex-1 p-0">{children}</CardContent>
      </Card>
      <Footer />
    </div>
  );
}
